import {
  AfterViewInit,
  ApplicationRef,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  Form,
  Field,
  Layout,
} from '../../../domain/form.interface';
import { Pagination } from '../../../domain/pagination.interface';
import { Subject, filter, switchMap, take, takeUntil, tap } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { ConfirmationDialogData, ModalConfirmationComponent } from '../../commons/modal-confirmation/modal-confirmation.component';
import { NgClass } from '@angular/common';
import Sortable from 'sortablejs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { setSelectedForm } from '../../../infrastructure/store/selectors/form.selector';
import { setSelectedVersion } from '../../../infrastructure/store/selectors/version.selector';
import { editForm } from '../../../infrastructure/store/actions/form.actions';
import { editVersion } from '../../../infrastructure/store/actions/version.actions';
import { selectConfig } from '../../../infrastructure/store/selectors/config.selector';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy, AfterViewInit {
  @Output() private changed = new EventEmitter<boolean>();
  
  unsubscribe$ = new Subject();

  formOptions = {}; // Fill web component input

  sortablesFieldsList: Sortable;
  sortablesFields: Sortable;
  sortablesCols: Sortable;
  sortablesRows: Sortable;

  elementSelected!: Form; // Element selected to toggle form-version
  forms: Form[] = []; // Forms lis
  formSelected!: Form; // Form selected
  versions: Form[] = [];
  versionSelected!: Form; // Version selected

  fields: Field[] = [];
  intersectedFields: Field[] = [];
  intersectedFieldsCopy: Field[] = [];
  fieldsIntersected = false;
  //formLayout: FormLayout;
  selectedField!: Field;
  //selectedForm!: Form;
  search: string = '';
  //paginator: Pagination = initialPagination;
  layout: Layout[] = [];
  editedLayout: Layout[] = [];
  //loadingFields = false;
  //loadingLayout = false;
  //updatingLayout = false;
  //cuurentPageId = 0;
  currentPage;
  currentPagePos;
  isPreview = false;
  paramsValue;
  changeDetected = false;
  urlBackend: string = "";

  constructor(
    private store: Store,
    private _renderer: Renderer2,
    private _element: ElementRef,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.store.select(selectConfig).pipe(
      filter(x => x.data['FORM_API']),
			take(1)   
    ).subscribe({
      next: (v) => {          
        if(v) {
          this.urlBackend = v.data['FORM_API'];
        }
      },
      error: (e) => {         
        console.log('ERROR->', <any>e);
      }
    });

    this.store
      .pipe(select(setSelectedForm))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {          
          this.formSelected = v;
          if(v) {
            this.isPreview = false;
            this.elementSelected = v;
            this.fields = [...v.fields];         
            this.layout = [...v.layout];
            this.editedLayout = [...v.layout];
            if(this.layout.length > 0) {
              this.currentPage = this.layout[0];
              this.currentPagePos = 0;
            } else {
              this.currentPage = null;
              this.currentPagePos = null;
            }
            console.log('::::fields->', this.fields)
            console.log('::::layout->', this.layout)
            console.log('::::editedLayout->', this.editedLayout)
            console.log('::::currentPage->', this.currentPage)
            this.cleanFieldsList();
            this.setFieldsDiff(this.layout);
            this.resetBuilderActions();
          }
        },
        error: (e) => {         
          console.log('ERROR->', <any>e);
        }
      });

    this.store
      .pipe(select(setSelectedVersion))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {
          this.versionSelected = v;
          if(v) {
            this.isPreview = false;
            this.elementSelected = v;
            this.fields = [...v.fields];         
            this.layout = [...v.layout];
            this.editedLayout = [...v.layout];
            if(this.layout.length > 0) {
              this.currentPage = this.layout[0];
              this.currentPagePos = 0;
            } else {
              this.currentPage = null;
              this.currentPagePos = null;
            }
            console.log('::::fields->', this.fields)
            console.log('::::layout->', this.layout)
            console.log('::::editedLayout->', this.editedLayout)
            console.log('::::currentPage->', this.currentPage)
            this.cleanFieldsList();
            this.setFieldsDiff(this.layout);
            this.resetBuilderActions();
          }        
        },
        error: (e) => {         
          console.log('ERROR->', <any>e);
        }
      });    
  }

  previewLayout() {
    console.log('Preview'); 
    this.setFormOptions(!this.isPreview);   
    this.isPreview = !this.isPreview;    
  }

  setFormOptions(preview: boolean) {
    this.formOptions = {
      formId: this.formSelected?.sk,
      versionId: this.elementSelected.pk == 'version' ? this.versionSelected?.sk : 'latest',
      page: this.currentPagePos + 1,
      isPreview: preview,
      urlBackend: this.urlBackend,
      form: {
        ...this.elementSelected,
        layout: this.editedLayout,
      }
    }
  }

  openNewTabWithQueryParams(route: string, queryParams: any): void {
    const url = this.constructUrl(route, queryParams);
    window.open(url, '_blank');
  }

  private constructUrl(route: string, queryParams: any): string {
    let url = route;
    if (queryParams) {
      url += '?' + this.serializeQueryParams(queryParams);
    }
    return url;
  }

  private serializeQueryParams(params: any): string {
    return Object.keys(params).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&');
  }

  save() {
    if(this.elementSelected.pk == 'form') {
      // Update form
      this.store.dispatch(
        editForm({
          form: {
            ...this.elementSelected,
            layout: this.editedLayout,
          },
        })
      );
    }
    if(this.elementSelected.pk == 'version') {
      // Update version
      this.store.dispatch(
        editVersion({
          formId: this.formSelected.sk,
          version: {
            ...this.elementSelected,
            layout: this.editedLayout,
          },
        })
      );
    }
  }

  getElementsNotInSecondArray(firstArray: Field[], secondArray: Field[]): Field[] {
    return firstArray.filter((elementFromFirstArray) => {
      // Check if the element is not present in the second array
      return !secondArray.some((elementFromSecondArray) => elementFromSecondArray.id === elementFromFirstArray.id);
    });
  }
  
  setFieldsDiff(layout: any) {
    let layoutFields = [];

      layout.forEach((page, h) => {
        page.rows.forEach((row, i) => {
          row.columns.forEach((col, j) => {
            layoutFields = layoutFields.concat(col.fields);
          });
        });
      });

      //let intersection = this.fields.filter((x) => layoutFields.includes(x));
      this.intersectedFields = this.getElementsNotInSecondArray(this.fields, layoutFields);
      //this.intersectedFieldsCopy = [...this.intersectedFields];
      this.fieldsIntersected = true;
      console.log('::::intersectedFields->', this.intersectedFields)

      //this.resetBuilderActions();
  }

  setCurrentPage(id, index) {
    this.currentPagePos = index;
    let page = this.editedLayout.filter((obj, index) => {
      return obj.id === id.toString();
    });
    this.currentPage = page[0];
    // Refresh preview input
    this.setFormOptions(this.isPreview);  
  }

  searchFields(search: string) {
    this.search = search;
  }

  selectField(field: Field) {
    console.log('Selected field:', field);
  }

  insertRow() {
    var foundIndex = this.editedLayout.findIndex(
      (x) => x.id == this.currentPage.id
    );
    this.editedLayout[foundIndex].rows.push(this.getEmptyRow());     
    this.resetBuilderActions();
  }

  insertRowUp(event) {
    console.log('insertRowUp->', event);
    const element =
      event.target.parentNode.parentNode.parentNode.parentNode.parentNode;
    this._renderer.insertBefore(
      element.parentNode,
      this.getRowStructure(),
      element
    );
    this.rebuildLayout();
    this.resetBuilderActions();
  }

  insertRowDown(event) {
    console.log('insertRowDown->', event);
    const element =
      event.target.parentNode.parentNode.parentNode.parentNode.parentNode
        .parentNode;
    const rowElement =
      event.target.parentNode.parentNode.parentNode.parentNode.parentNode
        .parentNode;
    const nextElement = element.nextSibling;

    if (
      nextElement &&
      nextElement.classList &&
      nextElement.classList.contains('mg-row-builder')
    ) {
      // No last row insert new row befor next one
      this._renderer.insertBefore(
        rowElement.parentNode,
        this.getRowStructure(),
        nextElement
      );
      this.rebuildLayout();      
      this.resetBuilderActions();
    } else {
      // Last row append new row
      this._renderer.appendChild(rowElement.parentNode, this.getRowStructure());
      this.rebuildLayout();      
      this.resetBuilderActions();
    }
  }

  getRowStructure() {
    const newElement1 = this._renderer.createElement('div');
    this._renderer.addClass(newElement1, 'mg-row-builder');
    this._renderer.addClass(newElement1, 'row');

    const newElement2 = this._renderer.createElement('div');
    this._renderer.addClass(newElement2, 'mg-col-wrapper');

    this._renderer.appendChild(newElement2, this.getColStructure());
    this._renderer.appendChild(newElement1, newElement2);

    return newElement1;
  }

  getColStructure() {
    const newElement1 = this._renderer.createElement('div');
    this._renderer.addClass(newElement1, 'mg-col-builder');
    this._renderer.addClass(newElement1, 'col');

    const newElement2 = this._renderer.createElement('div');
    this._renderer.addClass(newElement2, 'mg-col-center-action-container');
    this._renderer.addClass(newElement2, 'mg-col-actions');

    this._renderer.appendChild(newElement1, newElement2);

    return newElement1;
  }

  insertColLeft(event) {
    console.log('insertColLeft->', event);
    const element =
      event.target.parentNode.parentNode.parentNode.parentNode.parentNode;
    this._renderer.insertBefore(
      element.parentNode,
      this.getColStructure(),
      element
    );
    this.rebuildLayout();      
    this.resetBuilderActions();
  }

  insertColRight(event) {
    console.log('insertColRight->', event);
    const element =
      event.target.parentNode.parentNode.parentNode.parentNode.parentNode;
    const rowElement =
      event.target.parentNode.parentNode.parentNode.parentNode.parentNode
        .parentNode;
    const nextElement = element.nextSibling;

    if (
      nextElement &&
      nextElement.classList &&
      nextElement.classList.contains('mg-col-builder')
    ) {
      // No last col insert new col befor next one
      this._renderer.insertBefore(
        rowElement,
        this.getColStructure(),
        nextElement
      );
      this.rebuildLayout();      
      this.resetBuilderActions();
    } else {
      // Last col append new col
      this._renderer.appendChild(rowElement, this.getColStructure());
      this.rebuildLayout();      
      this.resetBuilderActions();
    }
  }

  addCol(row) {
    /*const page = row.parentNode.parentNode;

    const pagePos = page.getAttribute('data-pos');
    const rowPos = row.getAttribute('data-pos');

    console.log('PAGE:', pagePos);
    console.log('ROW:', rowPos);

    this.layout[pagePos].rows[rowPos].columns.push(this.getEmptyColumn());
    this.currentPage = this.layout[pagePos];

    console.log('CURRENT PAGE:', this.currentPage)

    this.resetBuilderActions();*/

    const colWrapper = row.querySelector('.mg-col-wrapper');
    this._renderer.appendChild(colWrapper, this.getColStructure());
    this.rebuildLayout();      
    this.resetBuilderActions();
  }

  deleteRow(event) {
    // TODO Check fields
    console.log('deleteRow->', event);
    let hasField = false;
    const row = event.target.parentNode.parentNode.parentNode;
    const page = row.parentNode.parentNode;
    const colWrapper = row.childNodes[1];

    const rowPos = row.getAttribute('data-pos');
    const pagePos = page.getAttribute('data-pos');

    colWrapper.childNodes.forEach((col, index) => {
      if (
        col.classList?.contains('mg-col-builder') &&
        this.elementChildrenHasClass(col.childNodes[1], 'mg-field-builder')
      ) {
        hasField = true;
      }
    });

    if (hasField) {
      this.openRelocateFieldModal();
    } else {
      //this.layout[pagePos].rows.splice(rowPos, 1);
      row.remove();
      this.rebuildLayout();
      this.resetBuilderActions();
    }
  }

  deleteCol(event) {
    // TODO Check fields
    console.log('deleteCol->', event);
    const col = event.target.parentNode.parentNode.parentNode;
    const row = col.parentNode.parentNode;
    const fieldContainer = col.childNodes[1];

    /*const page = row.parentNode.parentNode;

    const pagePos = page.getAttribute('data-pos');
    const rowPos = row.getAttribute('data-pos');
    const colPos = col.getAttribute('data-pos');

    console.log('PAGE:', pagePos);
    console.log('ROW:', rowPos);
    console.log('COL:', colPos);

    this.layout[pagePos].rows[rowPos].columns.splice(colPos, 1);
    this.currentPage = this.layout[pagePos];*/

    //this._renderer.removeChild(col.parentNode, col);

    if (this.elementChildrenHasClass(fieldContainer, 'mg-field-builder')) {
      this.openRelocateFieldModal();
    } else {
      col.remove();
      this.rebuildLayout();
      this.resetBuilderActions();
    }
  }

  getEmptyRow() {
    let row = {
      type: 'row',
      edit: true,
      columns: [this.getEmptyColumn()],
    };

    return row;
  }

  getEmptyColumn() {
    let column = {
      type: 'column',
      edit: true,
      fields: [],
    };
    return column;
  }

  addPage() {
    let currentPagePos = this.layout?.length == 0 ? 0 : this.layout?.length;

    console.log('LAYOUT->', this.layout)
    
    let page = {
      name: 'Page',
      description: 'Description',
      id: this.generateUniqueId(),
      rows: [this.getEmptyRow()],
    };

    console.log('Page:', page);
    
    //this.layout = [...this.layout, page];
    this.editedLayout = [...this.editedLayout, page];

    this.currentPage = page;

    currentPagePos = currentPagePos + 1;

    console.log('EDITED LAYOUT->', this.editedLayout)

    let change = !this.areObjectsEqual(this.layout, this.editedLayout);
    this.setChangeDetected(change);

    setTimeout(() => {
      this.resetBuilderActions();
    }, 100);
  }

  deletePage(index) {
    let hasField = false;
    
    this.currentPage.rows.forEach((row, i) => {
      row.columns.forEach((col, j) => {
        if (col.fields.length > 0) {
          hasField = true;
        }
      });
    });

    if (hasField) {
      this.openRelocateFieldModal();
    } else {
      //this.layout.splice(index, 1);
      this.editedLayout.splice(index, 1);

      if (index > 0) {
        this.currentPage = this.editedLayout[index - 1];
      } else {
        this.currentPage = this.editedLayout.length > 0 ? this.editedLayout[index] : null;
      }

      let change = !this.areObjectsEqual(this.layout, this.editedLayout);
      this.setChangeDetected(change);

      setTimeout(() => {
        this.resetBuilderActions();
      }, 100);
    }
  }

  generateAddColButton(row) {
    // Check if col exist and add col buttom
    const colWrapper = row.querySelector('.mg-col-wrapper');

    /*console.log('ROW->', row)
    console.log('WRAPPER->', colWrapper)
    console.log('WRAPPER CHILDS LENGHT->', colWrapper.childNodes.length)
    console.log('WRAPPER CHILDS ->', colWrapper.childNodes)
    console.log('WRAPPER CHILDS CLASSES->', colWrapper.childNodes.classList)
    console.log('WRAPPER FIRST CHILD->', colWrapper.childNodes[0])*/

    let generateAddColBtn = false; // Fix for DOM elements created by Angular

    if (
      colWrapper.childNodes.length > 0 &&
      !this.elementChildrenHasClass(colWrapper, 'mg-col-builder')
    ) {
      generateAddColBtn = true;
    }

    //console.log('generateAddColBtn->', generateAddColBtn)

    if (
      colWrapper &&
      (colWrapper.childNodes.length === 0 || generateAddColBtn)
    ) {
      const newElement22 = this._renderer.createElement('div');
      this._renderer.addClass(newElement22, 'mg-add-col-wrapper');
      this._renderer.addClass(newElement22, 'mg-builder');

      const newElement23 = this._renderer.createElement('button');
      this._renderer.addClass(newElement23, 'btn-style');
      this._renderer.addClass(newElement23, 'flex');
      this._renderer.addClass(newElement23, 'justify-content-center');
      this._renderer.addClass(newElement23, 'align-items-center');
      this._renderer.addClass(newElement23, 'mx-1');
      this._renderer.listen(newElement23, 'click', (event) => {
        this.addCol(row);
      });

      const newElement24 = this._renderer.createElement('span');
      this._renderer.addClass(newElement24, 'material-symbols-outlined');
      this._renderer.addClass(newElement24, 'icon-style');

      const newElement25 = this._renderer.createText('add');

      const newElement26 = this._renderer.createElement('span');
      this._renderer.addClass(newElement26, 'text-sm');

      const newElement6 = this._renderer.createText('Add Column');

      this._renderer.appendChild(newElement26, newElement6);
      this._renderer.appendChild(newElement24, newElement25);
      this._renderer.appendChild(newElement23, newElement24);
      this._renderer.appendChild(newElement23, newElement26);
      this._renderer.appendChild(newElement22, newElement23);
      this._renderer.appendChild(colWrapper, newElement22);
    }
  }

  generateColBuilderActions(page) {
    const colElements = page.querySelectorAll('.mg-col-builder');
    colElements.forEach((col, index) => {
      // SET COL POSITION
      this._renderer.setAttribute(col, 'data-pos', index);
      // COL LEFT
      const newElement1 = this._renderer.createElement('div');
      this._renderer.addClass(newElement1, 'mg-col-left-action-container');
      this._renderer.addClass(newElement1, 'mg-col-actions');
      this._renderer.addClass(newElement1, 'mg-builder');

      // COL LEFT TOP
      const newElement2 = this._renderer.createElement('div');
      this._renderer.addClass(newElement2, 'mg-col-top-left');
      this._renderer.addClass(newElement2, 'hide');

      const newElement3 = this._renderer.createElement('div');
      this._renderer.addClass(newElement3, 'col-element-name');
      const newElement4 = this._renderer.createText('Col');

      const newElement5 = this._renderer.createElement('mat-icon');
      this._renderer.addClass(newElement5, 'mg-move-element');
      this._renderer.addClass(newElement5, 'mat-icon');
      this._renderer.addClass(newElement5, 'material-icons');
      const newElement6 = this._renderer.createText('open_with');

      this._renderer.appendChild(newElement5, newElement6);
      this._renderer.appendChild(newElement3, newElement4);
      this._renderer.appendChild(newElement3, newElement5);
      this._renderer.appendChild(newElement2, newElement3);
      this._renderer.appendChild(newElement1, newElement2);

      // COL LEFT CENTER
      const newElement7 = this._renderer.createElement('div');
      this._renderer.addClass(newElement7, 'mg-col-center-left');
      this._renderer.addClass(newElement7, 'hide');

      const newElement8 = this._renderer.createElement('div');
      this._renderer.addClass(newElement8, 'icon-rounded-container');

      const newElement9 = this._renderer.createElement('div');
      this._renderer.addClass(newElement9, 'icon-rounded');
      this._renderer.listen(newElement9, 'click', (event) => {
        this.insertColLeft(event);
      });

      const newElement10 = this._renderer.createElement('mat-icon');
      this._renderer.addClass(newElement10, 'icon-rounded-text');
      this._renderer.addClass(newElement10, 'mat-icon');
      this._renderer.addClass(newElement10, 'material-icons');
      const newElement11 = this._renderer.createText('add');

      this._renderer.appendChild(newElement10, newElement11);
      this._renderer.appendChild(newElement9, newElement10);
      this._renderer.appendChild(newElement8, newElement9);
      this._renderer.appendChild(newElement7, newElement8);
      this._renderer.appendChild(newElement1, newElement7);

      // COL LEFT BOTTOM
      const newElement12 = this._renderer.createElement('div');
      this._renderer.addClass(newElement12, 'mg-col-bottom-left');
      this._renderer.addClass(newElement12, 'hide');

      const newElement13 = this._renderer.createElement('div');
      const newElement14 = this._renderer.createElement('p');

      this._renderer.appendChild(newElement13, newElement14);
      this._renderer.appendChild(newElement12, newElement13);

      this._renderer.appendChild(newElement1, newElement12);

      this._renderer.insertBefore(col, newElement1, col.firstElementChild);

      // COL RIGHT
      const newElement15 = this._renderer.createElement('div');
      this._renderer.addClass(newElement15, 'mg-col-right-action-container');
      this._renderer.addClass(newElement15, 'mg-col-actions');
      this._renderer.addClass(newElement15, 'mg-builder');

      // COL RIGHT TOP
      const newElement16 = this._renderer.createElement('div');
      this._renderer.addClass(newElement16, 'mg-col-top-right');
      this._renderer.addClass(newElement16, 'hide');

      const newElement17 = this._renderer.createElement('mat-icon');
      this._renderer.addClass(newElement17, 'mg-delete-element');
      this._renderer.addClass(newElement17, 'mat-icon');
      this._renderer.addClass(newElement17, 'material-icons');
      const newElement18 = this._renderer.createText('delete');
      this._renderer.listen(newElement17, 'click', (event) => {
        this.deleteCol(event);
      });

      this._renderer.appendChild(newElement17, newElement18);
      this._renderer.appendChild(newElement16, newElement17);
      this._renderer.appendChild(newElement15, newElement16);

      // COL RIGHT CENTER
      const newElement19 = this._renderer.createElement('div');
      this._renderer.addClass(newElement19, 'mg-col-center-rigth');
      this._renderer.addClass(newElement19, 'hide');

      const newElement20 = this._renderer.createElement('div');
      this._renderer.addClass(newElement20, 'icon-rounded-container');

      const newElement21 = this._renderer.createElement('div');
      this._renderer.addClass(newElement21, 'icon-rounded');
      this._renderer.listen(newElement21, 'click', (event) => {
        this.insertColRight(event);
      });

      const newElement22 = this._renderer.createElement('mat-icon');
      this._renderer.addClass(newElement22, 'icon-rounded-text');
      this._renderer.addClass(newElement22, 'mat-icon');
      this._renderer.addClass(newElement22, 'material-icons');
      const newElement23 = this._renderer.createText('add');

      this._renderer.appendChild(newElement22, newElement23);
      this._renderer.appendChild(newElement21, newElement22);
      this._renderer.appendChild(newElement20, newElement21);
      this._renderer.appendChild(newElement19, newElement20);
      this._renderer.appendChild(newElement15, newElement19);

      // COL RIGHT BOTTOM
      const newElement24 = this._renderer.createElement('div');
      this._renderer.addClass(newElement24, 'mg-col-bottom-rigth');
      this._renderer.addClass(newElement24, 'hide');

      const newElement25 = this._renderer.createElement('div');
      const newElement26 = this._renderer.createElement('p');

      this._renderer.appendChild(newElement25, newElement26);
      this._renderer.appendChild(newElement24, newElement25);
      this._renderer.appendChild(newElement15, newElement24);

      this._renderer.appendChild(col, newElement15);
    });
  }

  generateRowBuilderActions(page) {
    const rowElements = page.querySelectorAll('.mg-row-builder');

    rowElements.forEach((row, index) => {
      // SET ROW POSITION
      this._renderer.setAttribute(row, 'data-pos', index);
      // ROW TOP
      const newElement1 = this._renderer.createElement('div');
      this._renderer.addClass(newElement1, 'mg-row-top-action-container');
      this._renderer.addClass(newElement1, 'mg-row-actions');
      this._renderer.addClass(newElement1, 'mg-builder');

      // ROW TOP LEFT
      const newElement2 = this._renderer.createElement('div');
      this._renderer.addClass(newElement2, 'mg-row-left-top');
      this._renderer.addClass(newElement2, 'hide');

      const newElement3 = this._renderer.createElement('div');
      this._renderer.addClass(newElement3, 'row-element-name');
      const newElement4 = this._renderer.createText('Row');

      const newElement5 = this._renderer.createElement('mat-icon');
      this._renderer.addClass(newElement5, 'mg-move-element');
      this._renderer.addClass(newElement5, 'mat-icon');
      this._renderer.addClass(newElement5, 'material-icons');
      const newElement6 = this._renderer.createText('open_with');

      this._renderer.appendChild(newElement5, newElement6);
      this._renderer.appendChild(newElement3, newElement4);
      this._renderer.appendChild(newElement3, newElement5);
      this._renderer.appendChild(newElement2, newElement3);
      this._renderer.appendChild(newElement1, newElement2);

      // ROW TOP CENTER
      const newElement7 = this._renderer.createElement('div');
      this._renderer.addClass(newElement7, 'mg-row-center-top');
      this._renderer.addClass(newElement7, 'hide');

      const newElement8 = this._renderer.createElement('div');
      this._renderer.addClass(newElement8, 'icon-rounded-container');

      const newElement9 = this._renderer.createElement('div');
      this._renderer.addClass(newElement9, 'icon-rounded');
      this._renderer.listen(newElement9, 'click', (event) => {
        this.insertRowUp(event);
      });

      const newElement10 = this._renderer.createElement('mat-icon');
      this._renderer.addClass(newElement10, 'icon-rounded-text');
      this._renderer.addClass(newElement10, 'mat-icon');
      this._renderer.addClass(newElement10, 'material-icons');
      const newElement11 = this._renderer.createText('add');

      this._renderer.appendChild(newElement10, newElement11);
      this._renderer.appendChild(newElement9, newElement10);
      this._renderer.appendChild(newElement8, newElement9);
      this._renderer.appendChild(newElement7, newElement8);
      this._renderer.appendChild(newElement1, newElement7);

      // ROW TOP RIGHT
      const newElement12 = this._renderer.createElement('div');
      this._renderer.addClass(newElement12, 'mg-row-right-top');
      this._renderer.addClass(newElement12, 'hide');

      const newElement13 = this._renderer.createElement('mat-icon');
      this._renderer.addClass(newElement13, 'mg-delete-element');
      this._renderer.addClass(newElement13, 'mat-icon');
      this._renderer.addClass(newElement13, 'material-icons');
      const newElement14 = this._renderer.createText('delete');
      this._renderer.listen(newElement13, 'click', (event) => {
        this.deleteRow(event);
      });

      this._renderer.appendChild(newElement13, newElement14);
      this._renderer.appendChild(newElement12, newElement13);
      this._renderer.appendChild(newElement1, newElement12);

      this._renderer.insertBefore(row, newElement1, row.firstElementChild);

      // ROW BOTTOM
      const newElement15 = this._renderer.createElement('div');
      this._renderer.addClass(newElement15, 'mg-row-bottom-action-container');
      this._renderer.addClass(newElement15, 'mg-row-actions');
      this._renderer.addClass(newElement15, 'mg-builder');

      const newElement16 = this._renderer.createElement('div');
      this._renderer.addClass(newElement16, 'mg-row-center-bottom');
      this._renderer.addClass(newElement16, 'hide');

      const newElement17 = this._renderer.createElement('div');
      this._renderer.addClass(newElement17, 'mg-row-center-bottom');
      this._renderer.addClass(newElement17, 'hide');

      const newElement18 = this._renderer.createElement('div');
      this._renderer.addClass(newElement18, 'icon-rounded-container');

      const newElement19 = this._renderer.createElement('div');
      this._renderer.addClass(newElement19, 'icon-rounded');
      this._renderer.listen(newElement19, 'click', (event) => {
        this.insertRowDown(event);
      });

      const newElement20 = this._renderer.createElement('mat-icon');
      this._renderer.addClass(newElement20, 'icon-rounded-text');
      this._renderer.addClass(newElement20, 'mat-icon');
      this._renderer.addClass(newElement20, 'material-icons');
      const newElement21 = this._renderer.createText('add');

      this._renderer.appendChild(newElement20, newElement21);
      this._renderer.appendChild(newElement19, newElement20);
      this._renderer.appendChild(newElement18, newElement19);
      this._renderer.appendChild(newElement18, newElement19);
      this._renderer.appendChild(newElement17, newElement18);
      this._renderer.appendChild(newElement16, newElement17);
      this._renderer.appendChild(newElement15, newElement16);

      this._renderer.appendChild(row, newElement15);

      // Generate Add col buttom if required
      this.generateAddColButton(row);
    });
  }

  removeBuilderActions() {
    const builderElements = document.querySelectorAll('.mg-builder');
    builderElements.forEach((node) => {
      node.remove();
    });
  }

  generateBuilderActions() {
    const pageElements =
      this._element.nativeElement.querySelectorAll('.mg-page-builder');

    pageElements.forEach((page, i) => {
      this.generateRowBuilderActions(page);
      this.generateColBuilderActions(page);
    });
  }

  hideElementsByClass(className: string) {
    const elements = this._element.nativeElement.querySelectorAll(
      `.${className}`
    );

    for (const element of elements) {
      this._renderer.setStyle(element, 'display', 'none');
    }
  }

  showElementsByClass(className: string) {
    const elements = this._element.nativeElement.querySelectorAll(
      `.${className}`
    );

    for (const element of elements) {
      this._renderer.setStyle(element, 'display', 'block');
    }
  }

  elementChildrenHasClass(element, className): boolean {
    let hasClass = false;
    element.childNodes.forEach((child, i) => {
      if (child.classList?.contains(className)) {
        hasClass = true;
      }
    });
    return hasClass;
  }

  resetBuilderActions() {
    setTimeout(() => {
      this.removeBuilderActions();
      this.generateBuilderActions();
      this.initSortable();
    }, 100);
  }

  rebuildLayout() {
    //console.log('FIELDS-->', this.fields)
    console.log('REBUILD LAYOUT')
    const pageElements = this._element.nativeElement.querySelectorAll('.mg-page-builder');
    console.log('::::pageElements->', pageElements)   

    pageElements.forEach((page, i) => {
      this.editedLayout[i] = { ...this.editedLayout[i] };
      let rowElements = page.querySelectorAll('.mg-row-builder');
      let rowArray = [];
      rowElements.forEach((row, j) => {
        rowArray[j] = this.getEmptyRow();
        let colElements = row.querySelectorAll('.mg-col-builder');
        let colArray = [];
        colElements.forEach((col, k) => {
          colArray[k] = this.getEmptyColumn();
          let fieldElements = col.querySelectorAll('.mg-field-builder');
          let fieldArray = [];
          fieldElements.forEach((field, l) => {
            var result = this.fields.find((obj) => {
              return obj.name === field.getAttribute('data-name');
            });
            if (result && result !== undefined) {
              fieldArray.push(result);
            }

            //console.log('['+ i +']['+ j +']['+ k +']['+ field.getAttribute('data-name') +']')
          });
          colArray[k].fields = fieldArray;
        });
        rowArray[j].columns = colArray;
      });
      this.editedLayout[i].rows = [...rowArray];
    });

    console.log('::::editedLayout->', this.editedLayout);
    console.log('::::layout->', this.layout);
    console.log('::::currentPage->', this.currentPage);

    if(this.currentPage) {
      var page = this.editedLayout.find((obj) => {
        return obj.id === this.currentPage.id;
      });
      console.log('::::editedPage->', page);
      this.currentPage = page;
    }

    console.log('::::intersectedFields->', this.intersectedFields);
  
    let change = !this.areObjectsEqual(this.layout, this.editedLayout);
    this.setChangeDetected(change);
  }

  createFieldElement(field: any, parent: any) {
    // Create the main container div
    const container = this._renderer.createElement('div');
    this._renderer.addClass(container, 'card');
    this._renderer.addClass(container, 'mg-field-builder');

    // Set attributes using [attr.data-*]
    this._renderer.setAttribute(container, 'data-name', field.name);
    this._renderer.setAttribute(container, 'data-id', field.id);

    // Set click event using (click)
    this._renderer.listen(container, 'click', () => this.selectField(field));

    // Set ngClass
    //const ngClass = { 'card-selected': this.selectedField?.id === field.id };
    //this._renderer.setAttribute(container, 'class', '{{ngClass | class}}');

    // Create the content div
    const contentDiv = this._renderer.createElement('div');
    this._renderer.addClass(contentDiv, 'content');

    // Create the name span
    const nameSpan = this._renderer.createElement('span');
    this._renderer.addClass(nameSpan, 'name');
    this._renderer.setAttribute(nameSpan, 'matTooltip', field.name);
    const nameText = this._renderer.createText(
      field.name.length > 17
        ? `${field.name.slice(0, 17)}...`
        : field.name
    );
    this._renderer.appendChild(nameSpan, nameText);

    // Create the field-detail div
    const fieldDetailDiv = this._renderer.createElement('div');
    this._renderer.addClass(fieldDetailDiv, 'field-detail');
    this._renderer.addClass(fieldDetailDiv, 'd-flex');
    this._renderer.addClass(fieldDetailDiv, 'justify-content-between');

    // Create the type span
    const typeSpan = this._renderer.createElement('span');
    this._renderer.addClass(typeSpan, 'type');
    const typeText = this._renderer.createText(field.type);
    this._renderer.appendChild(typeSpan, typeText);
    this._renderer.appendChild(fieldDetailDiv, typeSpan);

    // Create the required span (conditionally)
    if (field.required) {
      const requiredSpan = this._renderer.createElement('span');
      this._renderer.addClass(requiredSpan, 'required');
      const requiredText = this._renderer.createText('Required');
      this._renderer.appendChild(requiredSpan, requiredText);
      this._renderer.appendChild(fieldDetailDiv, requiredSpan);
    }

    // Append child elements
    this._renderer.appendChild(contentDiv, nameSpan);
    this._renderer.appendChild(contentDiv, fieldDetailDiv);
    this._renderer.appendChild(container, contentDiv);

    // Create the mg-field-move-container div
    const moveContainerDiv = this._renderer.createElement('div');
    this._renderer.addClass(moveContainerDiv, 'mg-field-move-container');

    // Create the mg-field-move mat-icon
    const moveIcon = this._renderer.createElement('mat-icon');
    // Set attributes
    this._renderer.setAttribute(moveIcon, 'role', 'img');
    this._renderer.setAttribute(moveIcon, 'class', 'mat-icon notranslate mg-field-move material-icons mat-ligature-font mat-icon-no-color');
    this._renderer.setAttribute(moveIcon, 'aria-hidden', 'true');
    this._renderer.setAttribute(moveIcon, 'data-mat-icon-type', 'font');

    const moveIconText = this._renderer.createText('open_with');
    this._renderer.appendChild(moveIcon, moveIconText);
    this._renderer.appendChild(moveContainerDiv, moveIcon);
    this._renderer.appendChild(container, moveContainerDiv);

    // Append the main container to the parent element
    this._renderer.appendChild(parent, container);
  }

  restoreIntersectedFields() {
    this.cleanFieldsList();
    let sortableContainer = this.sortablesFieldsList.el;
    this.intersectedFields.forEach((field, index) => {
      this.createFieldElement(field, sortableContainer);
    });
  }

  cancelEditLayout() {
    this.isPreview = false;
    this.editedLayout = [...this.layout];
    this.restoreIntersectedFields();
    /*et fieldsTest = {...this.intersectedFields}
    console.log('INTERSECTED BEFORE DIFF->', this.intersectedFields)

    this.setFieldsDiff(this.layout);
    console.log('INTERSECTED->', this.intersectedFields)*/
    this.resetBuilderActions();
    if(this.layout.length > 0) {
      this.currentPage = this.layout[0];
    } else {
      this.currentPage = null;
    }
    this.setChangeDetected(false);    
  }

  setChangeDetected(change: boolean) {
    this.changeDetected = change;
    this.changed.emit(change);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }

  ngAfterViewInit() {
    this.generateBuilderActions();
    this.initSortable();
  }

  cleanFieldsList() {
    this.setChangeDetected(false);
    // Get the parent element by ID
    const parentElement = this._element.nativeElement.querySelector('#field-card-container');
    if (parentElement) {
      // Get all child elements
      const children = parentElement.children;
      // Iterate through children and retrieve data properties
      for (let i = 0; i < children.length; i++) {
        const child = children[i];
        const dataId = child.getAttribute('data-name');
        this._renderer.removeChild(parentElement, child);
      }
    }
  }

  initSortable() {
    /*SORTABLE*/
    const thisRef = this;

    const dragFieldList = this._element.nativeElement.querySelectorAll('.cards');
    dragFieldList.forEach((dragElement) => {
      this.sortablesFieldsList = Sortable.create(dragElement, {
        group: 'shared',
        handle: '.mg-field-move',
        ghostClass: 'field-sortable-ghost',
        animation: 150,
        onEnd() {
          thisRef.rebuildLayout();
          thisRef.resetBuilderActions();
        },
      });
    });

    const dragField = this._element.nativeElement.querySelectorAll(
      '.mg-col-center-action-container'
    );
    dragField.forEach((dragElement) => {
      this.sortablesFields = Sortable.create(dragElement, {
        group: 'shared',
        handle: '.mg-field-move',
        ghostClass: 'field-sortable-ghost',
        animation: 150,
        onEnd() {
          thisRef.rebuildLayout();
          thisRef.resetBuilderActions();
        },
      });
    });

    const dragCol = this._element.nativeElement.querySelectorAll('.mg-col-wrapper');
    dragCol.forEach((dragElement) => {
      this.sortablesCols = Sortable.create(dragElement, {
        group: 'shared-row',
        handle: '.col-element-name',
        ghostClass: 'col-sortable-ghost',
        animation: 150,
        onEnd() {
          thisRef.showElementsByClass('mg-add-col-wrapper');
          thisRef.rebuildLayout();
          thisRef.resetBuilderActions();
        },
        onStart() {
          thisRef.hideElementsByClass('mg-add-col-wrapper');
        },
      });
    });

    const dragRow = this._element.nativeElement.querySelectorAll('.mg-row-wrapper');
    dragRow.forEach((dragElement) => {
      this.sortablesRows = Sortable.create(dragElement, {
        group: 'shared-container',
        handle: '.row-element-name',
        ghostClass: 'row-sortable-ghost',
        animation: 150,
        onEnd() {
          thisRef.rebuildLayout();
          thisRef.resetBuilderActions();
        },
      });
    });
  }

  generateUniqueId(): string {
    // Generate a random number and convert it to a hexadecimal string
    const randomNumber: string = Math.floor(Math.random() * Date.now()).toString(16);
  
    // Concatenate the current timestamp with the random number
    const uniqueId: string = `${Date.now().toString(16)}${randomNumber}`;
  
    return uniqueId;
  }

  openRelocateFieldModal() {
    const dialogData: ConfirmationDialogData = {
      messagePrimary: `Relocate field(s) before delete this element.`,
      icon: `error`,
      messageSecondary: ``,
      confirmText: 'Ok'
    };

    const dialogRef = this.dialog.open(ModalConfirmationComponent, {
      height: '250px',
      width: '500px',
      data: dialogData,
    });
  }

  areObjectsEqual(obj1: any, obj2: any): boolean {
    if (obj1 === obj2) {
      return true;
    }
  
    // Check if both objects are null or undefined
    if (obj1 == null && obj2 == null) {
      return true;
    }
  
    // Check if only one of the objects is null or undefined
    if (obj1 == null || obj2 == null) {
      return false;
    }
  
    // Check if both objects have the same set of properties
    const obj1Keys = Object.keys(obj1);
    const obj2Keys = Object.keys(obj2);
  
    if (obj1Keys.length !== obj2Keys.length) {
      return false;
    }
  
    // Check if values of corresponding properties are equal
    for (const key of obj1Keys) {
      const val1 = obj1[key];
      const val2 = obj2[key];
  
      if (typeof val1 === 'object' && typeof val2 === 'object') {
        if (!this.areObjectsEqual(val1, val2)) {
          return false;
        }
      } else if (val1 !== val2) {
        return false;
      }
    }
  
    // Objects are equal
    return true;
  }

}
